import { render } from "./EditableItemImage.vue?vue&type=template&id=6fbfac9a&scoped=true&ts=true"
import script from "./EditableItemImage.vue?vue&type=script&lang=ts"
export * from "./EditableItemImage.vue?vue&type=script&lang=ts"

import "./EditableItemImage.vue?vue&type=style&index=0&id=6fbfac9a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fbfac9a"]])

export default __exports__